import { forwardRef } from 'react';

import { IconProps } from './icons.types';

import { SvgStyled } from './icons.styles';

export const LaptopIcon = forwardRef<SVGSVGElement, IconProps>(function LaptopIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.84 8.46558C1.29854 8.01186 1 7.12674 1 5.02782C1 2.9289 1.29854 2.04377 1.84 1.59005C2.1037 1.36908 2.50569 1.18302 3.18686 1.05617C3.87728 0.927589 4.78659 0.872045 6 0.872045C7.21341 0.872045 8.12272 0.927589 8.81314 1.05617C9.49431 1.18302 9.8963 1.36908 10.16 1.59005C10.7015 2.04377 11 2.9289 11 5.02782C11 7.12674 10.7015 8.01186 10.16 8.46558C9.8963 8.68656 9.49431 8.87261 8.81314 8.99947C8.12272 9.12804 7.21341 9.18359 6 9.18359C4.78659 9.18359 3.87728 9.12804 3.18686 8.99947C2.50569 8.87261 2.1037 8.68656 1.84 8.46558ZM6 10.0556C1.059 10.0556 0 9.16822 0 5.02782C0 0.88741 1.059 0 6 0C10.941 0 12 0.88741 12 5.02782C12 9.16822 10.941 10.0556 6 10.0556Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 11.564C1 11.3232 1.22386 11.128 1.5 11.128H10.5C10.7761 11.128 11 11.3232 11 11.564C11 11.8048 10.7761 12 10.5 12H1.5C1.22386 12 1 11.8048 1 11.564Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
